import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import './index.css';
import App from './App';
import rootReducer from "./rootReducer";
import registerServiceWorker from './registerServiceWorker';


const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

ReactDOM.render(
  <BrowserRouter>
      <Provider store={store}>
          <Route onUpdate={() => window.scrollTo(0, 0)} component={App} />
      </Provider>
  </BrowserRouter>,
  document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js